module.exports = __webpack_public_path__ + "img/dange.ee23b60a.png";